export const query = `query getStoreSettings {
    settings {
        taxOnProduct
    }
}`;
